import { TipoCaixaComponent } from './../caixa/tipo-caixa/tipo-caixa.component';
import { UnidadeComponent } from './../endereco-components/unidade/unidade.component';
import { TipoComponenteComponent } from './../endereco-components/tipo-componente/tipo-componente.component';
import { ModuloComponent } from './../endereco-components/modulo/modulo.component';
import { CentroCustoComponent } from './../cliente-components/centro-custo/centro-custo.component';
import { RamoatividadeComponent } from './../cliente-components/ramoatividade/ramoatividade.component';
import { Component, OnInit } from '@angular/core';
import { TipoenderecoComponent } from './../endereco-components/tipoendereco/tipoendereco.component';
import { TiporeajusteComponent } from './../cliente-components/tiporeajuste/tiporeajuste.component';
import { TipoclienteComponent } from './../cliente-components/tipocliente/tipocliente.component';
import { IndicereajusteComponent } from './../cliente-components/indicereajuste/indicereajuste.component';
import { GrupoclienteComponent } from './../cliente-components/grupocliente/grupocliente.component';

import {MatDialog} from '@angular/material/dialog';
import { ArmazemComponent } from '../endereco-components/armazem/armazem.component';
import { RegiaoComponent } from '../endereco-components/regiao/regiao.component';
import { GrupoProdutoComponent } from '../produto-components/grupo-produto/grupo-produto.component';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  public arrayString: string;
  public userAdministrativo = false;
  public userProduto = false;
  public user: any;
  public superUser = false;
  public createEmpresa = false;
  public editEmpresa = false;
  public deleteEmpresa = false;
  public viewEmpresa = false;
  public semPermisao = true;
  panelOpenState = false;

  constructor(public dialog: MatDialog,
    private router: Router) { }

  ngOnInit() {
    this.getAuthority();
  }

  openDialogTipoCliente() {
    const dialogRef = this.dialog.open(TipoclienteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogGrupoProdutos(){
    const dialogRef = this.dialog.open(GrupoProdutoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogRamoDeAtividade() {
    const dialogRef = this.dialog.open(RamoatividadeComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogGrupoDeCliente(){
    const dialogRef = this.dialog.open(GrupoclienteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogIndiceReajuste(){
    const dialogRef = this.dialog.open(IndicereajusteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoDeReajuste(){
    const dialogRef = this.dialog.open(TiporeajusteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogArmazem(){
    const dialogRef = this.dialog.open(ArmazemComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoDeEndereco(){
    const dialogRef = this.dialog.open(TipoenderecoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogRegiao() {
    const dialogRef = this.dialog.open(RegiaoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogCentroCusto() {
    const dialogRef = this.dialog.open(CentroCustoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogModulo() {
    const dialogRef = this.dialog.open(ModuloComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoComponente() {
    const dialogRef = this.dialog.open(TipoComponenteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoCaixa() {
    const dialogRef = this.dialog.open(TipoCaixaComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openDialogUnidade() {
    const dialogRef = this.dialog.open(UnidadeComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  goVincular() {
    this.router.navigate(['/vincular-empresa']);
  }

  goListarClientesPasta() {
    this.router.navigate(['/listagem-configurar-pasta']);
  }

  goImportarModelo() {
    this.router.navigate(['/importar-modelo']);
  }

  goPermissoesUsuario() {
    this.router.navigate(['listagem-usuarios-permissao']);
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_EMPRESA')) {
        this.viewEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('DELETE_EMPRESA')) {
        this.deleteEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('EDIT_EMPRESA')) {
        this.editEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('ADD_EMPRESA')) {
        this.createEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
        this.semPermisao = false;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/sidenav/sidenav.component.ts